module.exports = __webpack_public_path__ + "static/media/terminology-start.fcee8543.svg";